import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from "react";
import { esqueciSenha } from '../../../contexts/authentication';
import EmailInput from '../EmailInput';

interface ForgotPasswordProps {
  open: boolean;
  handleClose: () => void;
  setSuccessAlert: React.Dispatch<React.SetStateAction<boolean>>,
  setAlertMessage: React.Dispatch<React.SetStateAction<string>>,
  setAlert: React.Dispatch<React.SetStateAction<boolean>>,
}

export default function ForgotPassword({ open, handleClose, setSuccessAlert, setAlertMessage, setAlert }: ForgotPasswordProps) {
  const [email, setEmail] = useState<string>('');

  const handleClick = async () => {
    try {
      await esqueciSenha(email);
      handleClose();
      setAlertMessage('E-mail de redefinição de senha enviado com sucesso!');
      setSuccessAlert(true);
    } catch (error: any) {
      handleClose();
      if (error.code === 'auth/user-not-found') {
        setAlertMessage('Usuário nao encontrado.');
        setAlert(true);
      } else {
        setAlertMessage('Erro ao enviar e-mail de redefinição de senha.');
        setAlert(true);
      }
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: { backgroundImage: 'none' },
        },
      }}
    >
      <DialogTitle>Recriar senha</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Digite seu email, e enviaremos um link para redefinir sua senha.
        </DialogContentText>
        <EmailInput email={email} setEmail={setEmail} />
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>Cancelar</Button>
        {/* <Button variant="contained" type="submit"> */}
        <Button onClick={handleClick}>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}